"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var AbtaLogo = function AbtaLogo(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "170.1px",
    height: "170.1px",
    viewBox: "0 0 170.1 170.1"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M32,57c-0.6,0-1.2,0-1.9,0.1v3.2l0,0v35.1l0,0v1.2c0.6,0.1,1.2,0.1,1.9,0.1c11,0,19.9-8.9,19.9-19.9 S43,57,32,57 M39.2,78.7c-0.1,1.2-0.2,2.5-0.5,3.7h-4.6v-3.7H39.2z M34.1,75v-3.7h4.6c0.3,1.2,0.4,2.5,0.5,3.7L34.1,75z M43.1,78.7 h4.7c-0.1,1.3-0.4,2.5-0.9,3.7h-4.3C42.9,81.2,43.1,80,43.1,78.7 M43.2,75c-0.1-1.2-0.3-2.5-0.5-3.7h4.3c0.4,1.2,0.7,2.4,0.9,3.7 H43.2z M44.9,67.6h-3.4c-0.6-1.8-1.5-3.4-2.5-5C41.4,63.8,43.4,65.5,44.9,67.6 M37.7,67.6h-3.6v-6.5C35.6,63.1,36.8,65.2,37.7,67.6 M34.1,92.7v-6.6h3.6C36.9,88.5,35.7,90.7,34.1,92.7L34.1,92.7z M39.1,91.1c1-1.6,1.9-3.3,2.5-5H45C43.5,88.2,41.4,90,39.1,91.1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M96,94.4H85.5V61.5h10.3c6.6,0,9.7,4.5,9.7,8.5c0,3.1-1.3,5.2-3.9,6.8v0.1c3.8,0.8,6.1,3.5,6.1,7.5 C107.6,89.1,104.2,94.4,96,94.4 M95,66.6h-3.4v8.6h3.2c2.7,0,4.7-1.7,4.7-4.5C99.5,68.3,97.9,66.6,95,66.6 M96.1,80.2h-4.5v9.1h3.8 c4,0,6-1.8,6-4.8C101.4,81.9,99.5,80.2,96.1,80.2"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: fill,
    points: "131.8,66.5 123.1,66.5 123.1,94.3 117,94.3 117,66.5 107.5,66.5 107.5,61.5 133.8,61.5 \t"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M76.4,94.4l-3.2-8.2H61.4l-3,8.2h-6L65,61.5h4.5l13.2,32.9H76.4z M68.6,73.6c-0.5-1.3-0.9-2.7-1.3-4.1h-0.1 c-0.3,1.4-0.7,2.7-1.2,4l-2.9,7.6h8L68.6,73.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M151.6,94.4l-3.2-8.2h-11.7l-3,8.2h-6l12.7-32.9h4.5L158,94.4H151.6z M143.8,73.6c-0.5-1.3-0.9-2.7-1.2-4.1 h-0.1c-0.3,1.4-0.7,2.7-1.2,4l-2.9,7.7h8L143.8,73.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M28.3,73.1v-1.5l-9.5-9.5c-0.5,0.5-1,1-1.5,1.5l9.5,9.5H28.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M28.3,80.5V82l-9.5,9.5c-0.5-0.5-1-1-1.5-1.5l9.5-9.5L28.3,80.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M28.3,75h-16c-0.1,0.6-0.1,1.2-0.1,1.9c0,0.6,0,1.2,0.1,1.8h16L28.3,75z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M16.2,64.9c-1.8,2.4-3.1,5.3-3.7,8.3h11.9L16.2,64.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M28.3,69.3V57.4c-3,0.6-5.8,1.8-8.2,3.7L28.3,69.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M20,92.6c2.4,1.8,5.3,3.1,8.2,3.7V84.3L20,92.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M24.4,80.5H12.5c0.6,3,1.8,5.8,3.7,8.3L24.4,80.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M23,104.7h-2.6v8.2h-1.8v-8.2h-2.8v-1.5h7.6L23,104.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M27.2,107.5c-0.2-0.1-0.5-0.2-0.8-0.2c-0.5,0-1,0.3-1.3,0.6v4.9h-1.8v-6.9h1.5l0.2,0.7 c0.5-0.5,1.2-0.9,1.9-0.9c0.3,0,0.7,0.1,1,0.3L27.2,107.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M32.6,112.8l-0.3-0.6c-0.5,0.5-1.3,0.8-2,0.8c-1.2,0.1-2.2-0.8-2.3-2v-0.2c0-1.4,1.1-2.2,2.9-2.3l1.2,0v-0.2 c0-0.8-0.6-1.2-1.3-1.2c-0.6,0-1.3,0.2-1.8,0.5l-0.6-1.1c0.8-0.5,1.7-0.8,2.7-0.8c1.7,0,2.8,0.7,2.8,2.5v2.7c0,0.6,0,1.2,0.1,1.8 L32.6,112.8z M32.1,109.6l-1,0c-1,0-1.4,0.4-1.4,0.9s0.4,1,1.1,1c0.5,0,0.9-0.1,1.2-0.4L32.1,109.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M38.7,112.9h-1.3l-2.8-7h1.8l1.7,4.7h0l1.8-4.7h1.7L38.7,112.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M43.7,109.8c0,1,0.9,1.8,1.9,1.7c0,0,0,0,0,0l0,0c0.6,0,1.3-0.2,1.8-0.5l0.4,1.1c-0.7,0.5-1.6,0.8-2.5,0.7 c-2.4,0-3.4-1.8-3.4-3.6c0-2,1.2-3.6,3.1-3.6c1.9,0,3.1,1.4,3.1,3.6v0.5L43.7,109.8z M45,107.1c-0.8,0-1.4,0.7-1.4,1.5c0,0,0,0,0,0 l0,0h2.7C46.3,107.8,45.9,107,45,107.1L45,107.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M51.1,113c-1.2,0-1.6-0.7-1.6-1.5v-9h1.8v8.2c0,0.5,0.1,0.7,0.5,0.7c0.2,0,0.4,0,0.5-0.1l0.2,1.3 C52.1,112.9,51.6,113,51.1,113z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M64.5,112.9h-1.3l-1.6-4.7h0l-1.6,4.7h-1.3l-2.5-7h1.8l1.5,4.7h0l1.5-4.7h1.4l1.5,4.7h0l1.4-4.7H67L64.5,112.9 z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M69,104.8c-0.6,0-1-0.5-1-1.1c0-0.6,0.5-1,1.1-1c0.6,0,1,0.5,1,1C70.1,104.4,69.6,104.8,69,104.8z M68.1,112.8 v-6.9h1.8v6.9L68.1,112.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M74.1,113c-1.2,0-1.7-0.7-1.7-1.6v-4.1h-1.2v-1.3h1.2v-1.6l1.8-0.5v2.1h2.2l-0.5,1.3h-1.6v3.5 c0,0.5,0.2,0.8,0.7,0.8c0.4,0,0.8-0.2,1.2-0.4l0.5,1.1C75.7,112.7,74.9,112.9,74.1,113z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M81.9,112.8v-4c0-0.8-0.1-1.5-1-1.5c-0.6,0-1.2,0.3-1.7,0.7v4.8h-1.8v-10.4h1.8v4.2c0.6-0.6,1.5-0.9,2.3-0.9 c1,0,2.2,0.5,2.2,2.5v4.5L81.9,112.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M91.8,113c-2.3,0-3.4-1.6-3.4-3.6c-0.1-1.9,1.4-3.6,3.4-3.7H92c0.7,0,1.4,0.1,2,0.5l0,1.4 c-0.5-0.4-1.1-0.6-1.7-0.6c-1.2,0-2.1,1-2.1,2.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,1.2,0.6,2.2,2,2.2c0.6,0,1.1-0.2,1.6-0.5l0.4,1.2 C93.5,112.7,92.7,113,91.8,113z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M100.9,112c-1.3,1.4-3.5,1.5-4.9,0.2c-0.8-0.7-1.1-1.7-1.1-2.7c0-1,0.3-2,1-2.7c0.7-0.6,1.5-1,2.5-1 c0.9,0,1.9,0.3,2.5,1c0.6,0.7,1,1.7,0.9,2.6C101.9,110.3,101.6,111.3,100.9,112z M98.4,107.1c-1.1,0-1.7,0.9-1.7,2.2 s0.6,2.3,1.7,2.3c1.1,0,1.7-1,1.7-2.3C100.1,108.1,99.4,107.1,98.4,107.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M107.7,112.8v-4.1c0-0.7-0.1-1.5-1-1.5c-0.6,0.1-1.3,0.3-1.8,0.7v4.8h-1.7v-6.9h1.5l0.2,0.7 c0.7-0.6,1.5-0.9,2.4-0.9c1,0,2.2,0.6,2.2,2.5v4.6H107.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M115.1,104.1c-0.3-0.1-0.6-0.2-0.9-0.2c-0.6,0-0.8,0.3-0.8,0.9v1.1h1.8l-0.5,1.3h-1.4v5.6h-1.8v-5.6h-1v-1.3h1 v-1c0-2.1,1.5-2.5,2.4-2.5c0.5,0,0.9,0.1,1.4,0.3L115.1,104.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M117.3,104.8c-0.6,0-1-0.5-1-1.1c0-0.6,0.5-1,1.1-1c0.6,0,1,0.5,1,1C118.4,104.4,117.9,104.8,117.3,104.8z M116.4,112.8v-6.9h1.8v6.9L116.4,112.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M123.5,113c-2.1,0-3.8-1.2-3.8-3.6c0-2.2,1.6-3.7,3.8-3.7c0.3,0,0.6,0,0.9,0.1v-3.4h1.8v9.9 C125.4,112.8,124.5,113,123.5,113z M124.5,107.2c-0.3-0.1-0.5-0.1-0.8-0.1c-1.1-0.1-2.1,0.8-2.1,1.9c0,0.1,0,0.2,0,0.3 c-0.1,1.2,0.8,2.1,2,2.2c0,0,0,0,0,0h0.2c0.3,0,0.5,0,0.8-0.1L124.5,107.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M129.3,109.8c0,1,0.9,1.8,1.9,1.7c0,0,0,0,0,0l0,0c0.6,0,1.2-0.2,1.8-0.5l0.4,1.1c-0.7,0.5-1.6,0.8-2.5,0.8 c-2.4,0-3.4-1.8-3.4-3.6c0-2,1.2-3.6,3.1-3.6c1.9,0,3.1,1.4,3.1,3.6v0.5L129.3,109.8z M130.6,107.1c-0.8,0-1.4,0.7-1.4,1.5 c0,0,0,0,0,0l0,0h2.7C131.9,107.8,131.5,107,130.6,107.1L130.6,107.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M139.6,112.8v-4.1c0-0.7-0.1-1.5-1-1.5c-0.6,0.1-1.3,0.3-1.8,0.7v4.8H135v-6.9h1.5l0.2,0.7 c0.7-0.6,1.5-0.9,2.4-0.9c1,0,2.2,0.6,2.2,2.5v4.6L139.6,112.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M146.1,113c-2.3,0-3.4-1.6-3.4-3.6c-0.1-1.9,1.4-3.6,3.4-3.7h0.2c0.7,0,1.4,0.1,2,0.5l0,1.4 c-0.5-0.4-1.1-0.6-1.7-0.6c-1.2,0-2.1,1-2,2.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,1.2,0.6,2.2,2,2.2c0.6,0,1.1-0.2,1.6-0.5l0.4,1.2 C147.8,112.7,146.9,113,146.1,113z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M151,109.8c0,1,0.9,1.8,1.9,1.7c0,0,0,0,0,0l0,0c0.6,0,1.3-0.2,1.8-0.5l0.4,1.1c-0.7,0.5-1.6,0.8-2.5,0.8 c-2.4,0-3.4-1.8-3.4-3.6c0-2,1.2-3.6,3.1-3.6c1.9,0,3.1,1.4,3.1,3.6v0.5L151,109.8z M152.3,107.1c-0.8,0-1.4,0.7-1.4,1.5 c0,0,0,0,0,0l0,0h2.7C153.6,107.8,153.2,107,152.3,107.1L152.3,107.1z"
  })));
};
AbtaLogo.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
AbtaLogo.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = AbtaLogo;